import PrivilegeNames from '../../../constants/privilegeNames';

export const getUnitSearchForAppraisalComparison = (privileges, orgUnitId = null) => {
  if (privileges.includes(PrivilegeNames.UnitSearch)) {
    return '/data-reports/industry-reports/appraisal-comparison/unit-search';
  }

  if (privileges.includes(PrivilegeNames.UnitSelection)) {
    return '/data-reports/industry-reports/appraisal-comparison/unit-selection';
  }

  if (orgUnitId) {
    return `/data-reports/industry-reports/appraisal-comparison/${orgUnitId}`;
  }

  throw new Error('No Org Unit ID selected.');
};

export const getUnitSearchForOrgReports = (privileges, orgUnitId = null) => {
  if (privileges.includes(PrivilegeNames.UnitSearch)) {
    return '/data-reports/organization-reports/unit-reports/unit-search';
  }

  if (privileges.includes(PrivilegeNames.UnitSelection)) {
    return '/data-reports/organization-reports/unit-reports/unit-selection';
  }

  if (orgUnitId) {
    return `/data-reports/organization-reports/unit-reports/${orgUnitId}`;
  }

  throw new Error('No Org Unit ID selected.');
};

export const getUnitSearchForReportManagement = (privileges, orgUnitId = null) => {
  if (privileges.includes(PrivilegeNames.UnitSearch)) {
    return '/report-management/unit-search';
  }

  if (privileges.includes(PrivilegeNames.UnitSelection)) {
    return '/report-management/unit-selection';
  }

  if (orgUnitId) {
    return `/report-management/${orgUnitId}`;
  }

  throw new Error('No Org Unit ID selected.');
};

export const getUnitSearchForCheckPoints = (privileges, orgUnitId = null) => {
  if (privileges.includes(PrivilegeNames.UnitSearch)) {
    return '/check-points/unit-search';
  }

  if (privileges.includes(PrivilegeNames.UnitSelection)) {
    return '/check-points/unit-selection';
  }

  if (orgUnitId) {
    return `/check-points/${orgUnitId}`;
  }

  throw new Error('No Org Unit ID selected.');
};

export const getUnitSearchTarget = pathname => {
  return pathname.includes('/unit-search')
    ? pathname.split('/unit-search')[0]
    : pathname.split('/unit-selection')[0];
};

export const getOrgSearchForUserManagement = privileges => {
  return privileges.includes(PrivilegeNames.OrganizationSearch_Advanced)
    ? '/user-management/organization-search'
    : '/user-management';
};

export const getExecutiveSummaryUrl = privileges =>
  privileges.includes(PrivilegeNames.OrganizationSearch_Standard)
    ? '/data-reports/organization-reports/executive-summary/organization-search'
    : '/data-reports/organization-reports/executive-summary';

export const getLegalDocumentsUrl = privileges =>
  privileges.includes(PrivilegeNames.OrganizationSearch_Standard)
    ? '/legal-documents/organization-search'
    : '/legal-documents';
